module.exports = __webpack_public_path__ + "static/media/1.f9d3a13b.png";